<h1 mat-dialog-title>Your session has expired and you will have to login again to submit your logbook. Go to login?</h1>
<div class="row justify-content-between" align="center" mat-dialog-actions>

  <button mat-stroked-button
          class="text-blue-button"
          (click)="dialogRef.close(false)">
    Cancel
  </button>

  <button mat-stroked-button
          class="text-button"
          (click)="dialogRef.close(true)">
    OK
  </button>
</div>
